import React from "react";
import { useNavigate } from "react-router-dom";
import { useFetch, http } from "@/lib/api";
import { PageHeader, Loading, EmptyState, SectionTitle } from "@/components/common";
import { toast } from "sonner";
import { Star, Trash2 } from "lucide-react";

const KIND_ROUTE = {
  token: (id) => `/token/${id}`,
  wallet: (id) => `/wallet/${id}`,
  developer: (id) => `/developer/${id}`,
  narrative: () => `/narrative-radar`,
};
const KIND_COLOR = {
  token: "text-amber-400",
  wallet: "text-cyan-400",
  developer: "text-rose-400",
  narrative: "text-emerald-400",
};

export default function Watchlists() {
  const { data, loading, reload } = useFetch("/watchlists", []);
  const nav = useNavigate();

  const remove = async (id) => {
    await http.delete(`/watchlists/${id}`);
    toast.success("Removed from watchlist");
    reload();
  };

  const groups = {};
  (data?.data || []).forEach((it) => {
    (groups[it.kind] = groups[it.kind] || []).push(it);
  });

  return (
    <div className="fade-in">
      <PageHeader icon={Star} title="Watchlists" subtitle="Tokens, wallets, developers and narratives you are monitoring. Watchlists update automatically." />
      {loading ? <Loading /> : (data?.data?.length || 0) === 0 ? (
        <EmptyState icon={Star} title="Your watchlists are empty" hint="Use the Watch / Track buttons on token, wallet and developer pages to build your watchlists." />
      ) : (
        <div className="space-y-6">
          {Object.entries(groups).map(([kind, items]) => (
            <div key={kind}>
              <SectionTitle>{kind}s ({items.length})</SectionTitle>
              <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
                {items.map((it) => (
                  <div key={it.id} className="pnut-card flex items-center justify-between p-4">
                    <button onClick={() => nav(KIND_ROUTE[it.kind](it.ref_id))} className="text-left">
                      <div className={`font-semibold ${KIND_COLOR[it.kind]}`}>{it.label}</div>
                      <div className="text-[11px] text-slate-500">{it.sub}</div>
                    </button>
                    <button data-testid={`watch-remove-${it.id}`} onClick={() => remove(it.id)} className="rounded-md p-1.5 text-slate-500 hover:bg-rose-950/40 hover:text-rose-400">
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
